import { useEffect, useRef } from "react";
import { useAppSettings } from "@/hooks/useAppSettings";

/**
 * Appends " (DEV)" to document.title whenever the current environment
 * is NOT marked as production in app_settings.is_production.
 * Renders nothing.
 */
export default function DocumentTitleManager() {
  const { isProduction } = useAppSettings();
  const baseTitleRef = useRef<string | null>(null);

  useEffect(() => {
    if (baseTitleRef.current === null) {
      // Capture the original title once (strip any pre-existing "(DEV)" prefix or suffix).
      baseTitleRef.current = document.title
        .replace(/^\s*\(DEV\)\s*/i, "")
        .replace(/\s*\(DEV\)\s*$/i, "");
    }
    const base = baseTitleRef.current || "drumLog.Pro";
    document.title = isProduction ? base : `(DEV) ${base}`;
  }, [isProduction]);

  return null;
}
